import { PAStepModule } from "@/store/modules/paStep.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const stepListingMachine = Machine({
    id: "stepListingMachine",
    context: {},
    initial: "idle",
    states: {
        idle: {
            always: { target: "gettingSteps" },
        },
        gettingSteps: {
            invoke: {
                id: "gettingSteps",
                src: (context, event) => {
                    return PAStepModule.GetSteps();
                },
                onDone: { target: "loadedSteps" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedSteps: {
            on: {
                DELETE_STEP: { target: "deleteStep" },
                ORDER_STEP: { target: "orderStep" },
            },
        },
        orderStep: {
            on: {
                GETTING_STEPS: { target: "gettingSteps" },
            },
        },
        deleteStep: {
            tags: "showDeleteStepUI",
            on: {
                DELETING_STEP: { target: "deletingStep" },
                CANCEL_STEP: { target: "loadedSteps" },
            },
        },
        deletingStep: {
            tags: "showDeleteStepUI",
            invoke: {
                id: "deletingStep",
                src: (context, event) => {
                    return PAStepModule.DeleteStepById(event.stepId);
                },
                onDone: { target: "loadedSteps", actions: "showSuccessMessage" },
                onError: { target: "loadedSteps" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
    },
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default stepListingMachine;
